// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__-LM7J","title":"Info_title__19Csm","links":"Info_links__16br9","link":"Info_link__13UQx","logo":"Info_logo__2Thw4"};